import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {popupList_template} from "../components/templates/popupList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class popup extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected popupList: popupList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.popupList = new popupList_template("popupList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Popups List");
        return [this.popupList.build()];
    }

    protected getModuleName(): string {
        return "popup";
    }

    fillPage() {
        this.getPopupData();
    }

    protected getPopupData() {
        this.loadingIn(this.popupList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.popupList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/popup/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetPopupDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetPopupDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let popups = responseParsed.data;

                obj.viewModel.popupList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.popupList.setResultInfo(totalCount, totalPage, execTime)

                obj.popupList.setPopups(popups, obj.getBrandId());

            });
            obj.loadingOut(obj.popupList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected popupsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getPopupData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getPopupData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.popupList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.popupList.builtTemplate.children.namedItem("list-results"));

        let popupReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/popup/get/';
        let popupReq_params: Array<Array<string>> = [];
        popupReq_params.push(["data", ko.toJSON(this.popupList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(popupReq_url,popupReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.popupList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        // set popups list
        let popups = responseParsed.data;
        this.popupList.setPopups(popups, this.getBrandId());

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.popupList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.popupList.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewPopup(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/popups/view/' + id + '/')
    }

    protected addPopup() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/popups/add/')
    }

    protected deletePopup(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/popup/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.popupList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Popup" + "<strong>" + data.headline + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getPopupData()
                })

                obj.loadingOut(obj.popupList.builtTemplate.children.namedItem("list-results"));
            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().getApp().params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/popup.ts